<template>
  <div class="text-center">
    <v-dialog v-model="show" width="500">
      <v-card>
        <v-card-title class="justify-left">
          <h1 class="headline primary--text text--accent-2">
            {{ title }}
            <v-icon
              class="pt-3 pr-3"
              style="right:0px;top:0px;position:absolute;"
              color="primary"
              medium
              @click="show = false"
              >mdi-close</v-icon
            >
          </h1>
        </v-card-title>
        <v-card-text class="pt-5 pb-1">
          <CustomAlert class="px-5" :show-alert="showAlert" alert-type="error">
            <span class="body-2">{{ alertMessage }}</span>
          </CustomAlert>
          <span>{{ dialogContent }}</span>
          <v-col align="center" justify="middle"> </v-col>
          <br />
          <h4>{{ $cmsService.getContent(content, 'number_of_documents') }}</h4>
          <span class="primary--text text--accent-2">
            {{ orderValues.orderDocumentsAmount }}
          </span>
          <br />
          <h4>
            {{ $cmsService.getContent(content, 'number_of_lead_regions') }}
          </h4>
          <span class="primary--text text--accent-2">
            {{ orderValues.regionsAmount }}
          </span>
          <br />
          <h4>{{ $cmsService.getContent(content, 'sheet') }}</h4>
          <span class="primary--text text--accent-2">
            {{ orderValues.orderSheetAmount }}
          </span>
          <br />
          <h4>{{ $cmsService.getContent(content, 'weight') }}</h4>
          <span class="primary--text text--accent-2">
            {{ orderValues.orderWeight + ' g' }}
          </span>
          <br />
          <h4>{{ $cmsService.getContent(content, 'batches') }}</h4>
          <span class="primary--text text--accent-2">
            {{ orderValues.orderBatches }}
          </span>
        </v-card-text>
        <p></p>
        <v-divider class="py-1"></v-divider>
        <p></p>
        <v-card-actions class="pr-3 pb-3">
          <v-btn
            color="grey"
            class="white--text text-capitalize"
            @click="show = false"
            ><span>{{ $cmsService.getContent(content, 'cancel') }}</span></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="white--text text-capitalize"
            @click="triggerProduction"
            ><span>{{ button }}</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CustomAlert from '@/components/CustomAlert'
import dialogJson from '@/data/dialog.json'
export default {
  name: 'ProductionTriggerDialog',
  components: {
    CustomAlert
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showAlert: {
      type: Boolean,
      default: false
    },
    orderValues: {
      type: Object
    },
    title: {
      type: String,
      default: ''
    },
    alertMessage: {
      type: String,
      default: ''
    },
    dialogContent: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    },
    triggerProduction: {
      type: Function
    }
  },
  data: () => ({
    content: dialogJson.data
  }),
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
